/**
 * Shared password-policy rule used by every password-setting form
 * (Register, ResetPassword, ChangePasswordPage, Profile).
 * Mirrors the backend's Util/PasswordPolicy.java — keep both in sync.
 */
export const PASSWORD_REQUIREMENT_TEXT =
  'Password must be at least 8 characters and include at least one uppercase letter, one lowercase letter, and one digit';

export const isPasswordValid = (password) => {
  if (!password || password.length < 8) return false;
  return /[A-Z]/.test(password) && /[a-z]/.test(password) && /[0-9]/.test(password);
};
